module.exports = __webpack_public_path__ + "images/rdr2-b_rgba(0,0,0,0.7).jpg?v=bd398b04d2435a0a052e63d5db31ac1d";